import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const ClientForm = React.lazy(
  () => import('components/Client/Form/ClientForm'),
);

function ScreensClientForm(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} Client</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ClientForm
          id={params.id ? Number.parseInt(params.id as string, 10) : null}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensClientForm;
